// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2R3V-","buttons":"styles_buttons__2sW3z"};